export default __webpack_public_path__ + "static/media/icebox.f7e84628.jpeg";